import {
  Breadcrumbs,
  Box,
  Card,
  Typography,
  Link,
  Stack,
  CardContent,
} from "@mui/joy";
import { Outlet, useParams } from "react-router-dom";
import { Link as RouterLink } from "react-router-dom";
import { useTranslation } from "../../../i18n";
import OnlineUsersToggle from "../../../components/OnlineUsersToggle";
import HomeIcon from "@mui/icons-material/Home";
import ConversationsList from "./ConversationsList";
import ChatHeader from "./ChatHeader";
import ChatContent from "./ChatContent";

export default function Messages() {
  const { conversationId } = useParams();
  const t = useTranslation();

  return (
    <Box
      sx={{
        height: "100dvh",
        display: "flex",
        flexDirection: "column",
        m: 0,
        p: 0,
      }}
    >
      <Stack direction="row">
        <Breadcrumbs
          aria-label="breadcrumbs"
          sx={{
            "--Breadcrumbs-gap": "4px",
            m: 1,
          }}
          size="sm"
        >
          <Link component={RouterLink} color="neutral" to="/">
            <HomeIcon />
          </Link>
          <Typography level="title-sm">{t("DMs")}</Typography>
        </Breadcrumbs>
        <OnlineUsersToggle />
      </Stack>
      <Box
        sx={{
          flex: 1, // this fills the remaining vertical space
          mx: 2,
        }}
      >
        <Card
          sx={{
            backgroundColor: "hsl(0deg 0% 31.06% / 35%);",
            height: "100%",
            padding: 0,
            gap: 0,
          }}
        >
          {conversationId && (
            <ChatHeader conversationId={parseInt(conversationId, 10)} />
          )}

          <CardContent
            sx={{
              margin: 0,
              borderRadius: 6,
              border: "1px solid black",
              gap: 0,
            }}
          >
            <Box
              sx={{
                borderRadius: 6,
                flex: 1,
                width: "100%",
                mx: "auto",
              }}
            >
              {conversationId ? (
                <ChatContent conversationId={parseInt(conversationId, 10)} />
              ) : (
                <ConversationsList />
              )}
            </Box>
          </CardContent>
        </Card>
      </Box>
      <Outlet />
    </Box>
  );
}
